import { z } from "zod";
import {
  formElements as formElementsSchema,
  formId as formIdSchema,
  optionalIsoDateTime as optionalDeadlineSchema,
  schoolId as schoolIdSchema,
  submissionId as submissionIdSchema,
} from "../../shared/validation";

export const formsResponseSchema = z.object({
  forms: z.array(
    z.object({
      id: formIdSchema,
      name: z.string(),
      deadline: optionalDeadlineSchema,
      numberOfSubmissions: z.number().int().nonnegative(),
    })
  ),
});

export const submissionsResponseSchema = z.object({
  abgaben: z.array(
    z.object({
      submissionId: submissionIdSchema,
      data: z.array(z.string()),
    })
  ),
  labels: z.array(z.string()),
  linkId: formIdSchema,
  formName: z.string(),
  deadline: optionalDeadlineSchema,
  schule: schoolIdSchema.optional(),
  sharedWith: z.array(z.string()),
});

export const submitResponseSchema = z.union([
  z.object({
    error: z.literal("challenge_expired"),
    message: z.string(),
    challenge: z.string().min(1),
    retryAfterMs: z.number().int().min(0).max(10_000),
  }),
  z.object({
    result: z.literal("redirect"),
    url: z.string().min(1),
  }),
  z.object({
    error: z.string(),
    message: z.string(),
  }),
]);

export const editorResponseSchema = z.object({
  id: formIdSchema,
  schule: schoolIdSchema,
  schulname: z.string(),
  name: z.string(),
  content: formElementsSchema,
  deadline: optionalDeadlineSchema,
  users: z.array(z.string()),
  abgaben: z.null(),
  editingDisabled: z.enum(["abgaben", "demo"]).nullish(),
});

export type EditorResponse = z.infer<typeof editorResponseSchema>;
